<mat-card class="mat-elevation-z8">
  <form [formGroup]="booth_type_register_form">
    <div class="form-group">
      <label>Name <i class="material-icons"
        style="color: red;font-size: 14px;">star</i></label>
      <input type="text" class="form-control" formControlName='name'>
    </div>
    <div class="form-group">
      <label>Code <i class="material-icons"
        style="color: red;font-size: 14px;">star</i></label>
      <input type="text" class="form-control" formControlName='code'>
    </div>
    <button mat-raised-button color="primary" [disabled]="!booth_type_register_form.valid" (click)="registerBoothType()">{{action}}</button>
  </form>
</mat-card>
